import type { SVGProps } from "react";
export interface Certified01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Certified01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Certified01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M9.752 5.448c-.21.211-.497.33-.795.33H5.778v3.178c0 .299-.119.585-.33.796L3.2 11.999l2.248 2.248c.211.211.33.498.33.796v3.18h3.179l.22.022c.216.043.417.15.575.308L12 20.8l2.249-2.247.171-.141c.183-.122.4-.189.624-.189h3.18v-3.18c0-.298.119-.585.33-.795l2.247-2.25-2.247-2.246a1.13 1.13 0 0 1-.33-.796V5.778h-3.18c-.298 0-.584-.119-.795-.33L11.999 3.2zm10.721 3.043 2.047 2.046.14.157a2.07 2.07 0 0 1 0 2.612l-.14.158-2.047 2.045v2.894l-.011.211a2.07 2.07 0 0 1-1.848 1.847l-.21.012h-2.895l-2.045 2.046a2.07 2.07 0 0 1-2.77.141l-.157-.14-2.046-2.047H5.596a2.07 2.07 0 0 1-2.058-1.859l-.01-.21v-2.895l-2.046-2.045a2.07 2.07 0 0 1 0-2.927l2.046-2.046V5.596c0-1.142.926-2.068 2.068-2.068h2.895l2.046-2.047.157-.142a2.07 2.07 0 0 1 2.612 0l.158.142 2.045 2.047h2.895l.21.01a2.07 2.07 0 0 1 1.86 2.058v2.895Z"
      />
      <path
        fill={color}
        d="M14.704 8.705a1.125 1.125 0 0 1 1.591 1.59l-4.5 4.5c-.44.44-1.152.44-1.59 0l-2-2-.078-.086a1.125 1.125 0 0 1 1.584-1.582l.085.078L11 12.409z"
      />
    </svg>
  );
}
